import { render, staticRenderFns } from "./DiagnosticResultView.vue?vue&type=template&id=faf4f692&scoped=true"
import script from "./DiagnosticResultView.vue?vue&type=script&lang=js"
export * from "./DiagnosticResultView.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticResultView.vue?vue&type=style&index=0&id=faf4f692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf4f692",
  null
  
)

export default component.exports